import classNames from 'classnames'
import React from 'react'

import { ContentfulSizeChartSection } from '@src/quince-site-common/src/domains/contentful/ContentfulProduct'

import styles from '../sizeGuideV2.module.scss'

import UnitsToggleV2 from './UnitToggleV2'

interface SizeChartHeaderProps {
  headerTitle?: string
  onUnitsToggle: (index: number, selectedValue: string) => void
  selectedSizeChartSection?: ContentfulSizeChartSection
  sizeChartSections: ContentfulSizeChartSection[]
  activeUnitIndex: number
  hideUnitsTitle?: boolean
  showUnitsToggle?: boolean
}

const SizeChartHeaderV2 = (props: SizeChartHeaderProps) => {
  return (
    <>
      <div className={styles.headerContainer}>
        <div className={styles.headerTitle}>{props.headerTitle}</div>
        <UnitsToggleV2
          sizeChartSections={props.sizeChartSections}
          activeUnitIndex={props.activeUnitIndex}
          onUnitsToggle={props.onUnitsToggle}
          wrapperClassName={classNames(styles.unitsToggle, !props.showUnitsToggle && styles.unitsToggleHidden)}
        />
      </div>
    </>
  )
}

export default SizeChartHeaderV2
